import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import Swal from 'sweetalert2';

const server_backend = config.API_URL;

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const PasswordVerification = () => {
    const query = useQuery();
    const vc = query.get('vc');
    const vi = query.get('vi');
    const [TkVerified, setTkVerified] = useState(300);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const verifyPassword = async () => {
            try {
                const response = await axios.post(`${server_backend}/public/password_verification`, {
                    code: vc,
                    id: vi
                });
                console.log("Unexpected error, please check")
                if (response.data.RES_CODE === "00") {
                    setTkVerified(100);
                } else {
                    setTkVerified(200);
                    // Update user state here

                    setTimeout(() => {
                        navigate('/login');
                        window.location.reload()
                    }, 6000);
                }
            } catch (error) {
                alert("Sorry, the link has expired, please try again.");
            }
        };

        if (vc && vi) {
            verifyPassword();
        }
    }, [vc, vi]);


    const PasswordReset = async (e) => {
        e.preventDefault();


        if (password !== confirmPassword) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Passwords do not match',
                showConfirmButton: false,
                timer: 1500
            });
            return;
        }

        try {
            const response = await axios.post(`${server_backend}/public/password_reset`, {
                id: vi,
                code: vc,
                password: password,
                password_confirm: confirmPassword
            });

            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Password has been changed successfully',
                    showConfirmButton: false,
                });

                // Update user state here

                navigate('/login');
                window.location.reload()

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An unexpected error has occurred, please try again.',
                    showConfirmButton: false,
                    timer: 1000
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error has occurred, please try again',
                showConfirmButton: false,
                timer: 6000
            });
        }
    };

    return (

        <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
            <div className="bg-overlay"></div>
            {TkVerified === 100 ? (
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card overflow-hidden">
                                    <div className="row justify-content-center g-0">
                                        <div className="col-lg-6">
                                            <div className="p-lg-5 p-4">
                                                <h5 className="text-primary">Create new password</h5>
                                                <p className="text-muted">Your new password must be different from the previously used password.</p>
                                                <div className="p-2">
                                                    <form onSubmit={PasswordReset}>
                                                        <div className="mb-3">
                                                            <label className="form-label" htmlFor="password-input">Password</label>
                                                            <div className="position-relative auth-pass-inputgroup">
                                                                <input
                                                                    type="password"
                                                                    className="form-control pe-5 password-input"
                                                                    placeholder="Enter password"
                                                                    value={password}
                                                                    onChange={(e) => setPassword(e.target.value)}
                                                                    required
                                                                />
                                                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                                            </div>
                                                            <div id="passwordInput" className="form-text">Must be at least 8 characters.</div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label" htmlFor="confirm-password-input">Confirm Password</label>
                                                            <div className="position-relative auth-pass-inputgroup mb-3">
                                                                <input
                                                                    type="password"
                                                                    className="form-control pe-5 password-input"
                                                                    placeholder="Confirm password"
                                                                    value={confirmPassword}
                                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                                    required
                                                                />

                                                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="confirm-password-input"><i className="ri-eye-fill align-middle"></i></button>
                                                            </div>
                                                        </div>
                                                        <div id="password-contain" className="p-3 bg-light mb-2 rounded">
                                                            <h5 className="fs-14">Password must contain:</h5>
                                                            <p id="pass-length" className="invalid fs-13 mb-2">Minimum <b>8 characters</b></p>
                                                            <p id="pass-lower" className="invalid fs-13 mb-2">At least <b>one lowercase</b> letter (a-z)</p>
                                                            <p id="pass-upper" className="invalid fs-13 mb-2">At least <b>one uppercase</b> letter (A-Z)</p>
                                                            <p id="pass-number" className="invalid fs-13 mb-0">At least <b>one number</b> (0-9)</p>
                                                        </div>
                                                        
                                                        <div className="mt-4">
                                                            <button className="btn btn-warning w-100" type="submit">Reset Password</button>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="mt-5 text-center">
                                                    <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline">Click here</Link></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            ) : (TkVerified === 200 ? (
                <div>
                    <center>
                        <h6 className='text-white'>We are sorry, the recovery link has expired, try again, you will be returned to login automatically.</h6><br />
                        <div class="spinner-border text-primary" role="status">
                            <h1>_</h1>
                            <span class="sr-only">Loading...</span>
                        </div>
                    </center>
                </div>
            ) : (

                <div>
                    <center>
                        <h6 className='text-white'>validating please wait...</h6><br />
                        <div class="spinner-border text-primary" role="status">
                            <h1>_</h1>
                            <span class="sr-only">Loading...</span>
                        </div>
                    </center>
                </div>
            )

            )}

            {/* end auth page content */}
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <p className="mb-0">&copy; {new Date().getFullYear()} Velzon. Crafted with <i className="mdi mdi-heart text-danger"></i> by Themesbrand</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PasswordVerification;
